import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  AgentConfigurationsState,
  AgentConfiguration,
  AgentConfigurationsListData,
} from '../../types/agentConfigurations.types';

const initialState: AgentConfigurationsState = {
  agents: [],
  selectedAgent: null,
  loading: false,
  error: null,
  pagination: {
    page: 1,
    pageSize: 10,
    totalPages: 0,
    totalRecords: 0,
    hasMorePages: false,
  },
  search: '',
};

const agentConfigurationsSlice = createSlice({
  name: 'agentConfigurations',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setAgents: (state, action: PayloadAction<AgentConfigurationsListData>) => {
      state.agents = action.payload.agents;
      state.pagination = {
        ...state.pagination,
        totalPages: action.payload.totalPages,
        totalRecords: action.payload.totalRecords,
        hasMorePages: action.payload.hasMorePages,
      };
      state.loading = false;
      state.error = null;
    },
    setSelectedAgent: (state, action: PayloadAction<AgentConfiguration | null>) => {
      state.selectedAgent = action.payload;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.pagination.page = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pagination.pageSize = action.payload;
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
      state.pagination.page = 1;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearSelectedAgent: (state) => {
      state.selectedAgent = null;
    },
    updateAgent: (state, action: PayloadAction<AgentConfiguration>) => {
      const index = state.agents.findIndex((a) => a.id === action.payload.id);
      if (index !== -1) {
        state.agents[index] = action.payload;
      }
      if (state.selectedAgent?.id === action.payload.id) {
        state.selectedAgent = action.payload;
      }
    },
    resetAgentConfigurations: () => initialState,
  },
});

export const {
  setLoading,
  setError,
  setAgents,
  setSelectedAgent,
  setPage,
  setPageSize,
  setSearch,
  clearError,
  clearSelectedAgent,
  updateAgent,
  resetAgentConfigurations,
} = agentConfigurationsSlice.actions;

export default agentConfigurationsSlice.reducer;
